import React, {Component} from 'react';


class ResetFilterWindow extends Component {
    closeFilter(){
        document.body.classList.remove("show-filter");
    }

    resetFilters(){
        window.location.reload();
        localStorage.clear();
    }
    render() {
        
      return(
        <div className="filter-reset-bg">
            <div className="filter-window">
                <p>
                Weet je zeker dat je de geselecteerde filters wilt resetten?
                </p>
                <hr />
                <div className="window-button-row">
                    <div onClick={this.closeFilter}>
                        Annuleren
                    </div>
                    <div style={{color: '#e50056'}} onClick={this.resetFilters}>
                        RESETTEN
                    </div>
                </div>
            </div>
        </div>
      )
    }
};

export default ResetFilterWindow;

